export default {
    items: [],
    pendingInvoice: {},
    fetching: false,
    totalPaymentAmount: 0,
    paymentAlertModel: false,
    alertMessage: ''
};
